import React, { useState } from 'react'

import Image from 'next/image'

import * as S from './styles'
import { Text } from '..'
import { Chevron, BlueChevron } from '@/assets/icons'

export type DropdownProps = {
  /**
   * Dropdown label
   *
   * @example
   * ```tsx
   * <Dropdown label="2020" />
   * ```
   *
   *
   */
  label: string

  /**
   * Content of the Dropdown
   *
   * @example
   * ```tsx
   * <Dropdown content="lorem ipsum" />
   * ```
   *
   *
   */
  content: string

  /**
   * Width of the Dropdown
   *
   * @default 100%
   *
   * @example
   * ```tsx
   * <Dropdown width="50%" />
   * ```
   */
  width?: string
}

export const Dropdown: React.FC<DropdownProps> = ({
  label,
  content,
  width,
}) => {
  const [open, setOpen] = useState(false)
  const [hover, setHover] = useState(false)

  const handleMouseEnter = () => {
    setHover(true)
  }
  const handleMouseLeave = () => {
    setHover(false)
  }

  return (
    <S.DropdownContainer width={width}>
      <S.DropdownButton
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => setOpen(!open)}
      >
        <Text size="b2" className={open ? 'open-header' : undefined}>
          {label}
        </Text>

        <Image
          src={hover || open ? BlueChevron : Chevron}
          alt="chevron"
          className={open ? 'open-chevron' : undefined}
        />
      </S.DropdownButton>

      {open && (
        <div className="dropdown-body">
          <Text size="b3">{content}</Text>
        </div>
      )}
      <hr />
    </S.DropdownContainer>
  )
}
